import { render, staticRenderFns } from "./ButtonWithLoading.vue?vue&type=template&id=4a556c84&scoped=true&"
import script from "./ButtonWithLoading.vue?vue&type=script&lang=js&"
export * from "./ButtonWithLoading.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithLoading.vue?vue&type=style&index=0&id=4a556c84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a556c84",
  null
  
)

export default component.exports